import "../../styles/LabelStudioProject.css";
import "./LabelStudioProject.css";
import "../../styles/org-buttons.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import Timer from "../Timer";
import ImportStorageModal from "./ImportStorageModal/ImportStorageModal";
import ConfigModal from "./ConfigModal/ConfigModal";
import formatDate from "../../utils/time";
import { getUserCookie } from "../../utils/cookiesUtils";
import Cookies from "js-cookie";
import CreateModal from "./CreateModal/CreateModal";
import { buttonText } from "../../utils/buttonText";
import { notificationText } from "../../utils/notificationText";
import { pageText } from "../../utils/pageText";

function LabelStudioProject() {
  const [projectItems, setProjectItems] = useState([]);
  const [folderItems, setFolderItems] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [creating, setCreating] = useState(false);

  // 获取组织名
  const userData = getUserCookie();
  const userOrganizationName = userData ? userData.organization : null;

  const loadProjectList = async () => {
    const userToken = Cookies.get("user_token");
    if (!userToken) {
      setProjectItems([]);
      return;
    }
    axios
      .get(`/label_studio/projects/list?requesterToken=${userToken}`)
      .then((response) => {
        const newItems = response.data;
        setProjectItems(newItems.concat());
      })
      .catch((error) => {
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  // Folder 下拉：只显示 audio 数据集（排除 folder / table / Trash）
  const loadFolderList = async () => {
    const userToken = Cookies.get("user_token");
    if (!userToken) {
      setFolderItems([]);
      return;
    }
    axios
      .post("/datasets/list", { requesterToken: userToken })
      .then((response) => {
        let data = response.data;
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch {
            setFolderItems([]);
            return;
          }
        }
        const datasets = Array.isArray(data) ? data : [];
        const audioDatasets = datasets.filter(
          (ds) =>
            ds &&
            ds.media_type === "audio" &&
            ds.folder !== "Yes" &&
            ds.table !== "Yes" &&
            ds.group !== "Trash"
        );
        const items = audioDatasets.map((ds) => ({
          name: ds.name,
          type: "audio",
        }));
        setFolderItems(items);
      })
      .catch((error) => {
        const errorMsg = error.response?.data || error.message;
        window.alert(errorMsg);
      });
  };

  useEffect(() => {
    loadProjectList();
    loadFolderList();
  }, []);

  const audioFolderItems = folderItems;
  const completedTasks = projectItems.reduce(
    (total, item) => total + Number(item.finished_task_number || 0),
    0
  );
  const totalTasks = projectItems.reduce(
    (total, item) => total + Number(item.task_number || 0),
    0
  );

  const handleCreateProject = async (projectName, className, resetForm) => {
    setCreating(true);
    try {
      const userToken = Cookies.get("user_token");
      await axios.post("/label_studio/project/create", {
        title: projectName,
        class_name: className,
        requesterToken: userToken,
      });
      setShowCreateModal(false);
      if (resetForm) resetForm();
      await loadProjectList();
      window.alert(`Project ${projectName} Create successed`);
    } catch (error) {
      let errorMsg = error.response?.data || "Create project failed.";
      window.alert(errorMsg);
    }
    setCreating(false);
  };

  return (
    <div className="label-studio-projects">
      <section className="annotation-page-header">
        <div>
          <span className="annotation-page-eyebrow">{pageText("Annotation Workspace")}</span>
          <h1>{pageText("Label Studio Projects")}</h1>
          <p>{pageText("Manage audio annotation projects, storage imports, exports, and ETL handoff.")}</p>
        </div>
        <div className="annotation-page-stats">
          <div><span>{pageText("Projects")}</span><strong>{projectItems.length}</strong></div>
          <div><span>{pageText("Audio Sources")}</span><strong>{audioFolderItems.length}</strong></div>
          <div><span>{pageText("Tasks")}</span><strong>{totalTasks}</strong></div>
          <div><span>{pageText("Finished")}</span><strong>{completedTasks}</strong></div>
        </div>
      </section>

      <div className="annotation-toolbar">
        <div className="annotation-org-chip">
          <span>{pageText("Organization")}</span>
          <strong>{userOrganizationName || pageText("No organization")}</strong>
        </div>
        <button
          type="button"
          className="org-btn org-btn-primary"
          onClick={() => setShowCreateModal(true)}
        >
          {buttonText("+ Create Project")}
        </button>
      </div>
      <CreateModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onCreate={handleCreateProject}
        creating={creating}
      />
      <ProjectGallery
        loadProjectList={loadProjectList}
        items={projectItems}
        folders={audioFolderItems}
      />
    </div>
  );
}

function ProjectGallery(props) {
  const { loadProjectList, items, folders } = props;

  return (
    <div className="projectGallery">
      {items && items.length > 0 ? (
        items.map((item) => {
          return (
            <ProjectItem
              key={`ls-proj-${item.id}`}
              loadProjectList={loadProjectList}
              item={item}
              folders={folders}
            />
          );
        })
      ) : (
        <div className="annotation-empty-state">
          {pageText("No Label Studio projects yet. Create a project to start annotation.")}
        </div>
      )}
    </div>
  );
}

function ProjectItem(props) {
  const { item, loadProjectList, folders } = props;

  const [config, setConfig] = useState();
  const [reading, setReading] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteCardLoading, setDeleteCardLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [etlLoading, setEtlLoading] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCloseConfirmModal, setShowCloseConfirmModal] = useState(false);
  const [importStorageModalShow, setImportStorageModalShow] = useState(false);
  const [configModalshow, setConfigModalshow] = useState(false);

  const handleOpenImportModal = () => {
    setImportStorageModalShow(true);
  };

  const handleClearButtonClick = () => {
    setShowConfirmModal(true);
  };

  const handleShowCloseConfirmModal = () => {
    setShowCloseConfirmModal(true);
  };

  const handleETLButtonClick = async () => {
    await loadConfig();
    setConfigModalshow(true);
  };

  const loadConfig = async () => {
    setReading(true);
    axios
      .get(`/ETL/label_studio/config/read?project_id=${item.id}`)
      .then((response) => {
        setReading(false);
        let config = response.data;
        if (config) {
          setConfig(config);
        }
      })
      .catch((error) => {
        setReading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const deleteAllTasks = async () => {
    setDeleteLoading(true);
    axios
      .delete(`/label_studio/project/tasks/delete/all?project_id=${item.id}`)
      .then((response) => {
        setDeleteLoading(false);
        loadProjectList();
        let msg = `Delete all tasks in project '${item.title}' success.`;
        window.alert(msg);
        setShowConfirmModal(false);
      })
      .catch((error) => {
        setDeleteLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const deleteProject = async () => {
    setDeleteCardLoading(true);
    axios
      .delete(`/label_studio/project/delete?project_id=${item.id}`)
      .then((response) => {
        setDeleteCardLoading(false);
        loadProjectList();
        let msg = `Delete project '${item.title}' success.`;
        window.alert(msg);
        setShowCloseConfirmModal(false);
      })
      .catch((error) => {
        setDeleteCardLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const export_project = async () => {
    setExportLoading(true);
    axios
      .put(`/label_studio/project/export?project_id=${item.id}`)
      .then((response) => {
        setExportLoading(false);
        window.alert(
          `Export project '${item.title}' success, the export dir is '${item.export_dir}'`
        );
      })
      .catch((error) => {
        setExportLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const loadETL = async () => {
    setEtlLoading(true);
    axios
      .put(`/label_studio/project/ETL?project_id=${item.id}`)
      .then((response) => {
        setEtlLoading(false);
        window.alert(
          `ETL label-studio project '${item.title}' to table success`
        );
      })
      .catch((error) => {
        setEtlLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const StorageLinkStyle = {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  };

  return (
    <div className="card label-studio-project-card">
      <div className="card-content">
        <button
          type="button"
          className="btn btn-light project-open-button"
          onClick={() => {
            const w = window.open("about:blank");
            w.location.href = `http://${window.location.hostname}:8081/projects/${item.id}`;
          }}
        >
          <span className="annotation-card-kicker">{buttonText("Project")}</span>
          <h5 className="card-title" title={item.title}>{item.title}</h5>
        </button>
        <a
          onClick={() => {
            const w = window.open("about:blank");
            w.location.href = `http://${window.location.hostname}:8081/projects/${item.id}/settings/storage`;
          }}
          style={StorageLinkStyle}
        >
          {pageText("Check Storage")}
        </a>
        <div className="annotation-meta-grid">
          <div><span>{pageText("Created")}</span><strong>{formatDate(item.created_at)}</strong></div>
          <div><span>{pageText("Tasks")}</span><strong>{item.task_number}</strong></div>
          <div><span>{pageText("Finished")}</span><strong>{item.finished_task_number}</strong></div>
        </div>
        <div className="annotation-card-actions">
          <button
            type="button"
            className="org-btn org-btn-danger"
            onClick={handleClearButtonClick}
            disabled={item.task_number === 0}
          >
            {buttonText("Clear Data")}
          </button>
          <Modal
            show={showConfirmModal}
            onHide={() => setShowConfirmModal(false)}
            centered
          >
            <Modal.Header closeButton closeLabel={buttonText("Close")}>
              <Modal.Title>{notificationText("Clear Data")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                {notificationText(
                  "Data cannot be recovered after deletion, please proceed with caution."
                )}
              </p>
            </Modal.Body>
            <Modal.Footer className="org-modal-footer">
              <button
                type="button"
                className="org-btn org-btn-secondary"
                onClick={() => setShowConfirmModal(false)}
              >
                {buttonText("Cancel")}
              </button>
              <button
                type="button"
                className="org-btn org-btn-danger"
                onClick={deleteAllTasks}
              >
                {buttonText("Delete")}
              </button>
            </Modal.Footer>
          </Modal>
          <button
            type="button"
            className="org-btn org-btn-primary"
            onClick={handleOpenImportModal}
          >
            {buttonText("Import Storage")}
          </button>
        </div>
      </div>

      <ImportStorageModal
        show={importStorageModalShow}
        onHide={() => setImportStorageModalShow(false)}
        loadProjectList={loadProjectList}
        folders={folders}
        item={item}
      />

      <button
        onClick={handleShowCloseConfirmModal}
        type="button"
        className="btn-close top-right"
        aria-label={buttonText("Close")}
      />
      <Modal
        show={showCloseConfirmModal}
        onHide={() => setShowCloseConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton closeLabel={buttonText("Close")}>
          <Modal.Title>{notificationText("Close Project")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {notificationText("Are you sure you want to close this project?")}
          </p>
        </Modal.Body>
        <Modal.Footer className="org-modal-footer">
          <button
            type="button"
            className="org-btn org-btn-secondary"
            onClick={() => setShowCloseConfirmModal(false)}
          >
            {buttonText("Cancel")}
          </button>
          <button
            type="button"
            className="org-btn org-btn-danger"
            onClick={() => {
              deleteProject();
              setShowCloseConfirmModal(false);
            }}
          >
            {buttonText("Close")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export { LabelStudioProject };
